import React, { useContext } from 'react';
import { LoadingContext } from './LoadingContext';
import {DotLoading} from "antd-mobile";

const MyLoading = () => {
    // @ts-ignore
  const { isLoading } = useContext(LoadingContext);

    if (!isLoading) {
        return null;
    }

    return (
      <div style={{background: 'rgb(255,255,255,0.2)',position: 'absolute',top:0,left:0,right:0,bottom:0 ,display:"flex",alignItems:'center',justifyContent:'center'}}>
          <div style={{width:80,height:80,borderRadius:'15px'}}>
        <span style={{ fontSize: 24 }}>
          <DotLoading />
        </span></div>
      </div>
    );
};

export default MyLoading;
